
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-medicare-supplement/[stateSlug]/[citySlug]",
      function () {
        return require("private-next-pages/best-medicare-supplement/[stateSlug]/[citySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-medicare-supplement/[stateSlug]/[citySlug]"])
      });
    }
  